// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2e8e8499","239":"8270d0f9","732":"5b1e7bcc"}[chunkId] + ".chunk.js";
};